// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__TEpHx","subheader":"ReorderModal_subheader__Rf9Ir","listWrap":"ReorderModal_listWrap__vcRMu"};